module.exports = __webpack_public_path__ + "img/taobao.f55bb2d8.png";